import { Accordion } from "flowbite-react"
  const UiUxFAQ: React.FC = () => { return (
        <>
          <Accordion>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What is UI/UX design?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  The abbreviation for User Interface/User Experience design is UI/UX design. UX design is concerned with the interaction, senses, or experiences of application elements, whereas UI design is concerned with the graphical/cosmetic presentation of applications and software interfaces.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What is the difference between UI and UX designs?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  User Interface (UI) design is the visualization of an app, its interface, and how the user interacts with it. UX (User Experience) design is the overall concept and journey of the user interacting with the app, from start to finish.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> What are the best practices for UI and UX design?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Understanding user needs, conducting user research and usability testing, keeping designs consistent, creating an intuitive user experience, and focusing on mobile design are all best practices for UI and UX design. To create a modern and effective design, it is also necessary to stay up-to-date with the latest design trends.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">Which UI and UX design tools do you use?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  We leverage optimal UI and UX design tools such as Figma, Sketch, Adobe Photoshop, Adobe XD, Frammer, and Invision. The tools we use for UI/UX design will vary depending on the project, type of application, platform, and so on.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What is the cost of custom UI UX design services?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  The cost of UI/UX design services is largely determined by the projects complexity, the designers experience, and the time required to complete the project. Generally, the cost of custom design services ranges from $1500 to $5000.<br></br><br></br>
                  There are several other factors to consider, including the size of the project, the platform on which it will be created (mobile, web, etc.) and the number of features that need to be included. There is also a possibility that the designers hourly rate may also have an impact on the cost of a project. This is because it depends on how much research and testing were carried out.
                  </div>
                </Accordion.Content>
              </Accordion.Panel>
             
            </Accordion>
        </>
        )
}

export default UiUxFAQ
